import { render, staticRenderFns } from "./SsoIframes.vue?vue&type=template&id=7c1c6759&"
import script from "./SsoIframes.vue?vue&type=script&lang=js&"
export * from "./SsoIframes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports